// @ts-nocheck
import { getConfigEstimates } from "../../utils/methods/estimate/estimateMethods";
import {
  APPROVE_ESTIMATE_DATA_FAILURE,
  APPROVE_ESTIMATE_DATA_REQUEST,
  APPROVE_ESTIMATE_DATA_SUCCESS,
  FETCH_APPROVED_ESTIMATE_DATA_FAILURE,
  FETCH_APPROVED_ESTIMATE_DATA_REQUEST,
  FETCH_APPROVED_ESTIMATE_DATA_SUCCESS,
  FETCH_SUBMITTED_ESTIMATE_DATA_FAILURE,
  FETCH_SUBMITTED_ESTIMATE_DATA_REQUEST,
  FETCH_SUBMITTED_ESTIMATE_DATA_SUCCESS,
  FETCH_UNSUBMITTED_POSITIONS_FAILURE,
  FETCH_UNSUBMITTED_POSITIONS_REQUEST,
  FETCH_UNSUBMITTED_POSITIONS_SUCCESS,
  GET_ESTIMATES_OF_CONFIG_FAILURE,
  GET_ESTIMATES_OF_CONFIG_REQUEST,
  GET_ESTIMATES_OF_CONFIG_SUCCESS,
  SUBMIT_DEPOSIT_INVOICE_DATA_FAILURE,
  SUBMIT_DEPOSIT_INVOICE_DATA_REQUEST,
  SUBMIT_DEPOSIT_INVOICE_DATA_SUCCESS,
  SUBMIT_ESTIMATE_DATA_FAILURE,
  SUBMIT_ESTIMATE_DATA_REQUEST,
  SUBMIT_ESTIMATE_DATA_SUCCESS,
  SWITCH_ESTIMATE_CONFIG,
  UPDATE_CLIENT_APPROVE_DATA,
} from "../constants/estimateData";
import { GET_ALL_REIM_AND_DEDUC_OF_EVENT_SUCCESS } from "../constants/event/adjustments";
import { store } from "../store";

const initialValues = {
  estimate: {
    eventInfo: null,
    contactInfo: null,
    coordinators: [],
    sessions: [],
    positions: {},
    estimateGeneratedAt: null,
  },
  approvedEstimate: {
    eventInfo: null,
    contactInfo: null,
    coordinators: [],
    sessions: [],
    positions: {},
    estimateGeneratedAt: null,
  },
  estimateId: null,
  isLoading: false,
  dLoading: false,
  isConfigLoading: false,
  isEstimateAvailable: null,
  isSubmittedEstimateAvailable: null,
  clientApproved: null,
  isRevisedEstimateGenerated: false,
  configEstimates: null,
  unSubmittedPositions: {
    new: [],
    updated: [],
    deleted: [],
    deletedPositions: [],
  },
};

const estimateData = (state = initialValues, action) => {
  switch (action?.type) {
    // approved estimate data action
    case FETCH_APPROVED_ESTIMATE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        approvedEstimate: {},
        isEstimateAvailable: false,
        estimateId: null,
      };

    case FETCH_APPROVED_ESTIMATE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        approvedEstimate: {},
        isEstimateAvailable: false,
      };

    case FETCH_APPROVED_ESTIMATE_DATA_SUCCESS:
      const newPositions = {};
      const newSessions = action?.payload?.sessions?.map((ses) => {
        const { positions, ...rest } = ses;
        newPositions[ses?._id] = [
          ...(ses?.positions?.map((item) => ({
            ...item,
            session: { _id: ses?._id, sessionName: ses?.sessionName },
          })) || []),
        ];
        return rest;
      });

      return {
        ...state,
        isLoading: false,
        approvedEstimate: {
          eventInfo: {
            tax: action?.payload?.tax,
            terms: action?.payload?.terms,
            eventId: action?.payload?.eventId,
            estimate: action?.payload?.estimate,
            estimatedProfit: action?.payload?.estimatedProfit,
            grandTotalEstimate: action?.payload?.grandTotalEstimate,
          },
          contactInfo: {
            ...action?.payload?.contactInformation,
          },
          sessions: newSessions,
          positions: newPositions,
        },
        isEstimateAvailable: true,
        estimateId: action?.payload?._id,
      };

    // submitted estimate data action
    case FETCH_SUBMITTED_ESTIMATE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        estimate: {},
        isEstimateAvailable: false,
        estimateId: null,
        isSubmittedEstimateAvailable: null,
      };

    case FETCH_SUBMITTED_ESTIMATE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        estimate: {},
        isEstimateAvailable: false,
        isSubmittedEstimateAvailable: false,
      };

    case FETCH_SUBMITTED_ESTIMATE_DATA_SUCCESS:
      const estimatePositions = {};
      const newEstimateSessions = action?.payload?.sessions?.map((ses) => {
        const { positions, ...rest } = ses;
        estimatePositions[ses?._id] = [
          ...(ses?.positions?.map((item) => ({
            ...item,
            session: { _id: ses?._id, sessionName: ses?.sessionName },
          })) || []),
        ];
        return rest;
      });

      return {
        ...state,
        isLoading: false,
        clientApproved: action?.payload?.clientApproved || null,
        isRevisedEstimateGenerated:
          action?.payload?.isRevisedEstimateGenerated || false,
        estimate: {
          eventInfo: {
            tax: action?.payload?.tax,
            terms: action?.payload?.terms,
            eventId: action?.payload?.eventId,
            estimate: action?.payload?.estimate,
            estimatedProfit: action?.payload?.estimatedProfit,
            grandTotalEstimate: action?.payload?.grandTotalEstimate,
          },
          estimateGeneratedAt: action?.payload?.estimateGeneratedAt,
          contactInfo: {
            ...action?.payload?.contactInformation,
          },
          sessions: newEstimateSessions,
          positions: estimatePositions,
        },
        isEstimateAvailable: true,
        estimateId: action?.payload?._id,
        PONumber: action?.payload?.PONumber,
        estimateNumber: action?.payload?.estimateNumber,
        isSubmittedEstimateAvailable: !!action?.payload?.grandTotalEstimate,
      };

    // submit estimate data action
    case SUBMIT_ESTIMATE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case SUBMIT_ESTIMATE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case SUBMIT_ESTIMATE_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    // submit estimate data action
    case SUBMIT_DEPOSIT_INVOICE_DATA_REQUEST:
      return {
        ...state,
        dLoading: true,
      };

    case SUBMIT_DEPOSIT_INVOICE_DATA_SUCCESS:
      return {
        ...state,
        dLoading: false,
      };

    case SUBMIT_DEPOSIT_INVOICE_DATA_FAILURE:
      return {
        ...state,
        dLoading: false,
      };

    // approve estimate data aciton
    case APPROVE_ESTIMATE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case APPROVE_ESTIMATE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case APPROVE_ESTIMATE_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    // unsubmitted positions data
    case FETCH_UNSUBMITTED_POSITIONS_REQUEST:
      return {
        ...state,
        // isLoading: true,
      };

    case FETCH_UNSUBMITTED_POSITIONS_SUCCESS:
      return {
        ...state,
        // isLoading: false,
        unSubmittedPositions: {
          new: action?.payload?.newAddedPositions,
          updated: action?.payload?.editedPositions,
          deleted: action?.payload?.deletedPositions,
          deletedPositions: action?.payload?.deletedPositionsDetails || [],
        },
      };
    case FETCH_UNSUBMITTED_POSITIONS_FAILURE:
      return {
        ...state,
        // isLoading: false,
      };

    // update client approve data
    case UPDATE_CLIENT_APPROVE_DATA:
      return {
        ...state,
        clientApproved: action?.payload?.clientApproved || false,
        isRevisedEstimateGenerated: true,
      };

    // latest estimate of every config
    case GET_ESTIMATES_OF_CONFIG_REQUEST:
      return {
        ...state,
        isConfigLoading: true,
      };

    case GET_ESTIMATES_OF_CONFIG_SUCCESS: {
      // 🔴 O backend devolve UM DOCUMENTO aqui, não uma lista: `getLatestConfig`
      // (`estimates.service.ts:598-601`) é `cfgEstModel.findOne({eventId}).sort(...)`.
      // O `getConfigEstimates` faz `configs?.forEach(...)`
      // (`utils/methods/estimate/estimateMethods.ts:1435`) — em objeto isso é TypeError,
      // lançado DENTRO do reducer. O throw aborta o dispatch, o state nunca atualiza e
      // `isConfigLoading` fica preso em `true` PARA SEMPRE → a tela de detalhe do evento
      // trava num spinner eterno e MUDO (`EventDetailsClient.tsx`, 3º termo do gate).
      // ⚠️ Só o CLIENTE via o bug: `getSubmittedLatestConfigEstimate` é `@Roles('client')`,
      // então admin/superAdmin tomam 403 e nunca chegam neste reducer — foi o que fez o
      // chamado parecer "abre pro Osh e não abre pro cliente" (Will Redenbaugh / Westin
      // Boston Copley, 04/08: "When I navigate to the current event, it never loads").
      // Normalizamos aqui em vez de mudar o contrato do backend: o `findOne` é lido por
      // outros pontos e trocar por array exigiria deploy de BE pra corrigir bug de FE.
      const raw = action?.payload;
      const list = Array.isArray(raw) ? raw : raw ? [raw] : [];
      let configs = getConfigEstimates({ configs: list });
      return {
        ...state,
        isConfigLoading: false,
        configEstimates: configs,
        estimate: configs?.[Object.keys(configs)?.[0]],
        // Era `action?.payload?.length > 0` — em objeto dá `undefined > 0` = false, o que
        // escondia o estimate mesmo quando ele existia. Segundo bug do mesmo assume-array.
        isEstimateAvailable: list.length > 0,
      };
    }

    case GET_ESTIMATES_OF_CONFIG_FAILURE:
      return {
        ...state,
        isConfigLoading: false,
      };

    // switch config
    case SWITCH_ESTIMATE_CONFIG:
      return {
        ...state,
        estimate: state?.configEstimates?.[action?.payload],
      };

    default:
      return state;
  }
};

export default estimateData;
export { initialValues };